import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { Outlet } from 'react-router';
import { Header } from './Header';
import { Footer } from 'components/Footer/Footer';
import Loading from 'components/Loading/Loading';
import { useAppSelector, useAppDispatch } from 'store/store';
import { removeAlert } from 'store/reducers/alertReducer';

import './_layout.scss';

export const PageLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const locked = useAppSelector((state) => state.lock.locked);
  const alerts = useAppSelector((state) => state.alerts.alerts);

  return (
    <div className="psf-page">
      <Header />

      <main className="psf-page__content">
        <Outlet />
      </main>

      <Footer />

      {locked && (
        <div className="psf-lock-screen">
          <Loading />
        </div>
      )}

      {alerts.map((alert) => (
        <Snackbar key={alert.id} open={true} autoHideDuration={6000} onClose={() => dispatch(removeAlert(alert.id))} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={() => dispatch(removeAlert(alert.id))} severity={alert.severity === 'warning' ? 'error' : 'success'} sx={{ width: '100%' }}>
            {alert.message}
          </Alert>
        </Snackbar>
      ))}
    </div>
  );
};
